import v4u from "../images/v4uLogo.webp";
import hoagies from "../images/HoagiesLogo.webp";
import tubbees from "../images/Tubbees_Logo_New.webp";
import snusDaddy from "../images/SnusDaddy.webp";
import Map from "./Map";
import Nav from "./Nav";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RTW from "../images/RTW.webp";
import Snappy from "../images/snappyLogo2.png";
import Footer from "./Footer";
import awardsJourney from "./racetrack_awards_journey.json";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/react-splide/css";
import Hero from "./Hero";

const awardTimeline = awardsJourney.timeline
  .filter((milestone) => Number.isFinite(Number(milestone.year)))
  .sort((first, second) => Number(second.year) - Number(first.year));

export default function Home() {
  const [activeAwardYear, setActiveAwardYear] = useState(
    awardTimeline[0].year,
  );

  // fetch racetrack
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const res = await axios.get(
          "https://maps.rt-itservices.co.uk?site=RaceTrack",
        );

        setLocations(res.data?.sites || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchLocations();
  }, []);

  const [showLocations, setShowLocations] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setShowLocations(window.innerWidth > 1200);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const homeBrands = [
    {
      name: "Vaped4U",
      logo: v4u,
      url: "https://vaped4u.com/",
      description:
        "You can find Vaped4U within our stores, showcasing an incredible variety of vapes within one place. From e-liquids to pods to starter kits, Vaped4U have it all.",
    },
    {
      name: "Tubbees Dessert Lab",
      logo: tubbees,
      url: "https://tubbees.co.uk/",
      description:
        "We are proud to have Tubbees Dessert Lab inside our stores. Tubbees takes desserts to the next level, offering a world of imported treats, a variety of mouth-watering desserts and up to 96 flavours of slush across their stores.",
    },
    {
      name: "Snus Daddy",
      logo: snusDaddy,
      url: "https://snusdaddy.co.uk/",
      description:
        "Brand new to our stores, SnusDaddy is one of the largest retailers for tobacco-free nicotine pouches. SnusDaddy offer a large assortment of authentic Snus, legally imported into the UK.",
    },
    {
      name: "Hoagies",
      logo: hoagies,
      url: "https://hoagies.co.uk/",
      description:
        "A recent addition, we now have Hoagies in our stores. Fancy a hot drink? Hoagies. Fancy a sandwich? Hoagies. Fancy a hot dog? Hoagies. Hoagies are here for your lunchtime and snacking cravings.",
    },
  ];

  return (
    <div className="home">
      <Nav />
      <Hero />

      {/* test about sectionm strats */}
      <section id="aboutSection" className="home-about-section">
        <div className="home-about-overlay"></div>

        <div className="container home-about-container">
          <div className="home-about-content">
            <span className="home-section-eyebrow">RaceTrack Pitstop</span>

            <h2 className="Who">Who Are We?</h2>

            <p>
              We are an ambitious convenience store and petrol station retailer
              with multiple locations across Glasgow, and we continue to grow.
            </p>

            <p>
              We bring an experience like no other. Stepping into RaceTrack
              Pitstop, you’ll be amazed. Our stores bring you more than a great
              everyday household product range. Visiting our stores is more than
              just a trip to the local convenience store.
            </p>
          </div>

          <div className="home-brand-carousel">
            <Splide
              options={{
                type: "loop",
                drag: "free",
                focus: "center",
                perPage: 3,
                gap: "30px",
                arrows: false,
                pagination: false,
                autoScroll: {
                  speed: 1,
                  pauseOnHover: true,
                  pauseOnFocus: false,
                },
                breakpoints: {
                  1200: {
                    perPage: 2,
                  },
                  700: {
                    perPage: 1,
                  },
                },
              }}
              extensions={{ AutoScroll }}
              aria-label="RaceTrack Pitstop brands"
            >
              {homeBrands.map((brand) => (
                <SplideSlide key={brand.name}>
                  <article className="home-brand-card">
                    <a
                      className="home-brand-link"
                      href={brand.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="home-brand-image"
                        src={brand.logo}
                        alt={`${brand.name} Logo`}
                      />
                    </a>

                    <div className="home-brand-content">
                      <h6 className="home-brand-title">{brand.name}</h6>

                      <div className="home-brand-description">
                        {brand.description}
                      </div>
                    </div>
                  </article>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        </div>
      </section>
      {/* Test about sectiuon ends */}

      {/* test find us start */}
      <section id="findUs" className="home-findus-section">
        <div className="home-findus-overlay"></div>

        <div className="container home-findus-container">
          <div className="home-findus-header">
            <h2>Where can you find us?</h2>
          </div>
          <div className="explorer-mobile-container">
            <a href="/locations" className="explorer-link">
              Explore Locations
            </a>
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 12H5m14 0-4 4m4-4-4-4"
              />
            </svg>
          </div>
          <div className="home-findus-layout">
            <aside className="home-locations-sidebar">
              <h3
                style={{ color: "white" }}
                onClick={() => navigate("/locations")}
              >
                Our Locations →
              </h3>

              <div className="home-locations-list">
                {locations.map((location) => (
                  <button
                    key={location._id}
                    type="button"
                    className="home-location-button"
                    onClick={() =>
                      navigate(`/${encodeURIComponent(location.name)}`)
                    }
                  >
                    <span>{location.name}</span>
                    <span className="home-location-arrow">→</span>
                  </button>
                ))}
              </div>
            </aside>

            <div className="home-map-wrapper">
              <Map locations={locations} />
            </div>
          </div>
        </div>
      </section>

      {/* test find us end */}

      <section id="deals">
        <h3 className="shopOnline">SHOP ONLINE AT</h3>

        <div className="row">
          <a
            href="https://racetrackwow.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={RTW} alt="Racetrackwow logo" />
          </a>

          <a
            href="https://www.snappyshopper.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Snappy} alt="Snappy Shopper logo" />
          </a>
        </div>
      </section>

      <section id="awards">
        <div className="awards-intro">
          <span className="home-section-eyebrow">Our journey</span>
          <h2>Recognition that moves us forward</h2>
          <p>
            From our first recognition in 2019 to the work we continue today,
            explore the milestones that have shaped RaceTrack Pitstop.
          </p>
        </div>

        <div className="journey-explorer">
          <nav className="journey-years" aria-label="Awards journey years">
            <span className="journey-years-label">Explore by year</span>
            {awardTimeline.map((milestone, index) => (
              <button
                key={milestone.year}
                type="button"
                className={activeAwardYear === milestone.year ? "is-active" : ""}
                onClick={() => setActiveAwardYear(milestone.year)}
              >
                <span>{String(milestone.year).toUpperCase()}</span>
                <small>{String(index + 1).padStart(2, "0")}</small>
              </button>
            ))}
          </nav>

          {awardTimeline.map((milestone) =>
            activeAwardYear === milestone.year ? (
              <article className="journey-feature" key={milestone.year}>
                <div className="journey-feature-top">
                  <span className="journey-feature-year">
                    {String(milestone.year).toUpperCase()}
                  </span>
                  <span className="journey-feature-count">
                    {milestone.awards.length} {milestone.awards.length === 1 ? "award" : "awards"}
                  </span>
                </div>
                <h3>{milestone.title}</h3>
                <p className="journey-feature-description">{milestone.description}</p>
                {milestone.awards.length > 0 ? (
                  <div className="journey-awards-grid">
                    {milestone.awards.map((award, awardIndex) => (
                      <div className="journey-award" key={`${award.award}-${awardIndex}`}>
                        <div className="journey-award-image">
                          {award.image?.url ? (
                            <img src={award.image.url} alt={award.image.alt || award.award} />
                          ) : (
                            <span>★</span>
                          )}
                        </div>
                        <div>
                          <strong>{award.award}</strong>
                          <small>{award.recipient}</small>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="journey-next">
                    <span>→</span>
                    <strong>The journey continues</strong>
                  </div>
                )}
              </article>
            ) : null,
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
